import {shade} from "polished"
import type {DefaultTheme} from "styled-components"
import {merge} from "lodash"
import {Branding} from "@irati/types"
import BrandingStream from "@irati/brand/streams/branding"
import mainTheme, {DARK_MODIFIER, HOVER_MODIFIER, SHADE_MODIFIER, perkboxBlue} from "../theme"
import {updateLegacyBrand} from "../colors"

export default function updateBranding(setTheme: (theme: DefaultTheme) => void) {
  BrandingStream.subscribe((branding) => {
    if (branding) {
      const {default: defaultColor, shade: shadeColor, dark, hover} = makeBrand(branding)
      const brand = {
        default: defaultColor,
        shade: shadeColor,
        dark,
        hover,
        textColour: branding.textColour,
        primaryColour: branding.primaryColour
      }
      setTheme(merge({}, mainTheme, {colors: {brand}}))
      updateLegacyBrand(brand)
    }
  })
}

function makeBrand(branding: Branding) {
  const brandColor = branding.primaryColour || perkboxBlue
  return {
    default: brandColor,
    shade: `${shade(SHADE_MODIFIER, brandColor)}`,
    dark: `${shade(DARK_MODIFIER, brandColor)}`,
    hover: `${shade(HOVER_MODIFIER, brandColor)}`
  }
}
